import { get, post, deleteApi, postJson, patch } from "../jhk/axios.js";
import {
  get as get2,
  deleteApi as post2,
  deleteApi as deleteAp2i,
  postJson as postJson2,
  patch as patch2,
} from "../axios.js";

const test = (data) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(data);
    }, 500);
  });
};

// 活动概览（复盘）
export const getActivityOverviewList = (p) =>
  get(`/activityReview/activityOverview`, p);

// 效果汇总字段设置查询接口
export const getFieldList = (p) => {
  return get(`/PointActivityEffectDetails/fieldJsonConfig/query`, p);
};

// 效果汇总字段设置接口
export const saveFieldList = (p) => {
  return postJson(`/PointActivityEffectDetails/fieldJsonConfig/save`, p);
};

// 入会转化分析
export const getMemberConversionList = (p) =>
  get(`/activityReview/openCardConversionOverview`, p);

// 奖品数据
export const getPrizeDataList = (p) =>
  get(`/activityReview/prizeSendOverview`, p);

// 导出（复盘）
export const activityReviewExport = (p) =>
  postJson(`/activityReview/export`, p);

// 活动统计（云起）-导出
export const yunqiStatsExport = (p) =>
  postJson2(`/PointActivityEffectDetails/yunqiStats/export`, p);

// 活动统计（云起）-活动概览
export const yunqiStatsActivityOverview = (p) =>
  get2(`/PointActivityEffectDetails/yunqiStats/activityOverview`, p);

// 活动统计（云起）-入会转化概览
export const openCardConversionOverview = (p) =>
  get2(`/PointActivityEffectDetails/yunqiStats/openCardConversionOverview`, p);

// 活动统计（云起）-奖品发放总览
export const prizeSendOverview = (p) => {
  return get2(`/PointActivityEffectDetails/yunqiStats/prizeSendOverview`, p);
};

// 活动统计（云起）-活动概览-趋势统计
export const yunqiStatsActivityOverviewTrend = (p) => {
  return get2(`/PointActivityEffectDetails/yunqiStats/activityOverviewTrend`, p);
};
